import client from '../client';

const trackScreen = (pageName, props, options = {}) => {
  client.page(pageName, props, options);
};

export default trackScreen;
